import { render, staticRenderFns } from "./BaseSendNotificationDialog.vue?vue&type=template&id=58c9296f&"
import script from "./BaseSendNotificationDialog.vue?vue&type=script&lang=js&"
export * from "./BaseSendNotificationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c9296f')) {
      api.createRecord('58c9296f', component.options)
    } else {
      api.reload('58c9296f', component.options)
    }
    module.hot.accept("./BaseSendNotificationDialog.vue?vue&type=template&id=58c9296f&", function () {
      api.rerender('58c9296f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseSendNotificationDialog.vue"
export default component.exports